import React from 'react';
import PropTypes from 'prop-types';
import useInterval from 'use-interval';
import { useToggle } from 'react-use';
import ConfirmActivityModal from './ConfirmActivityModal';

const ACTIVITY_TIMEOUT = 2 * 60 * 1000; // 2 minutes

const TimeoutActivity = (props) => {
  const [showConfirmActivityModal, toggleActivityModal] = useToggle(false);
  
  useInterval(() => {
      toggleActivityModal(true);
  }, ACTIVITY_TIMEOUT);
  
  const close = () => {
      toggleActivityModal(false);
      props.onTimeout();
  };

  if ( !showConfirmActivityModal ) return null;
  return (
    <ConfirmActivityModal
      onConfirm={close}
      onTimeout={close}
      timeoutDurationInSeconds={props.timeoutDurationInSeconds}
      confirmText="CLOSE"
      headerText="We've noticed you've been inactive"
      descriptionText="This page will now refresh."
    />
  );
};

TimeoutActivity.propTypes = {
  onTimeout: PropTypes.func.isRequired,
  timeoutDurationInSeconds: PropTypes.number.isRequired
};

export default TimeoutActivity;
